export class SubmitRequestError extends Error {
  public static errorName = 'SubmitRequestError';

  public constructor(message) {
    super(message);
    this.name = SubmitRequestError.errorName;
  }
}
